var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuizChoiceForm',_vm._g({attrs:{"data":_vm.data,"staticAnswers":false,"showImageUpload":true,"title":_vm.$t('QUIZZES.LABEL.SELECT_IMAGE'),"showManualCheck":_vm.showManualCheck}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }